import React, { useState, useEffect } from 'react';
import Jobs_header from '../Header/Jobs_header';
import back_arrow from "../../assets/svg/back-arrow.svg";
import { useNavigate, useLocation } from "react-router-dom";
import "../../styles/Jobs.css";
import small_line from "../../assets/svg/small_line.svg";
import download_arrow from "../../assets/svg/download_arrow.svg";
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import axiosInstance from '../../axiosInstance';
import CommonFooter from '../../CommonFooter/CommonFooter';

const GenerateCostViewPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [jobData, setJobData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [allCategories, setAllCategories] = useState([]);

    // If job data is passed via state, use it directly
    const initialJob = state?.job || {};
    const jobId = initialJob.id || initialJob.job_id;
    const [selectedRows, setSelectedRows] = useState([]);
    useEffect(() => {
        const fetchJobDetails = async () => {
            if (!jobId) {
                setIsLoading(false);
                return;
            }

            try {
                setIsLoading(true);

                // const response = await axios.get(
                //     `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/job/edit/${jobId}`
                // );

                const response = await axiosInstance.get(
                    `/job/edit/${jobId}`
                );

                if (response.data && response.data.success) {
                    console.log("Job Data:", response.data.data);
                    const job = response.data.data;
                    setJobData(job);

                    const costLines = job.cost_lines || [];
                    // Transform the data to match your category structure
                    const costRows = costLines.map(line => ({
                        joblineId: line.id,
                        remarks: line.remarks,
                        chargecode: line.charge_code,
                        description: line.description_of_charges,
                        costunitQuantity: parseFloat(line.unit_of_quantity) || 0,
                        vendor: line.vendor_name || "",
                        costRemarks: line.remarks || "",
                        costRate: parseFloat(line.unit_of_rate) || 0,
                        costNetTotal: parseFloat(line.net_total) || 0,
                        costAccrual: parseFloat(line.accrual) || 0,
                        costAttachmentUrl: line.attachment_url || null,
                        costStatus: line.cost_status || null,
                        costContractValue: parseFloat(line.contract_value) || 0,
                        costInvStatus: line.cost_invoice_status || "",
                        po_wo_number: line.po_wo_number || "",
                        po_wo_date: line.po_wo_date || "",
                        vendorInvNumber: line.vendor_inv_number || "",
                        vendorInvDate: line.vendor_inv_date || "",
                    }));

                    // Category totals
                    const costNetTotal = costRows.reduce((sum, row) => sum + row.costNetTotal, 0);
                    const costAccrual = costRows.reduce((sum, row) => sum + row.costAccrual, 0);
                    const transformedCategory = {
                        id: job.job_id,
                        jobnumber: job.job_no,
                        costRows,
                        costNetTotal,
                        costAccrual,

                    };
                    setAllCategories([transformedCategory]);
                } else {
                    // Fall back to the initial job data if available
                    if (Object.keys(initialJob).length > 0) {
                        setJobData(initialJob);
                        const transformedCategory = {
                            id: initialJob.id,
                            jobnumber: initialJob.job_no,
                            costRows: []
                        };
                        setAllCategories([transformedCategory]);
                    }
                }
            } catch (err) {
                console.error("Error fetching job details:", err);
                // Fall back to the initial job data if available
                if (Object.keys(initialJob).length > 0) {
                    setJobData(initialJob);
                    const transformedCategory = {
                        id: initialJob.id,
                        jobnumber: initialJob.job_no,
                        costRows: []
                    };
                    setAllCategories([transformedCategory]);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchJobDetails();
    }, [jobId, initialJob]);


    const calculateCategoryTotals = (category) => {
        const costTotals = category.costRows.reduce((totals, row) => {
            return {
                quantity: totals.quantity + (parseFloat(row.costunitQuantity) || 0),
                rate: totals.rate + (parseFloat(row.costRate) || 0),
                netValue: totals.netValue + (parseFloat(row.costNetTotal) || 0),
                accrual: totals.accrual + (parseFloat(row.costAccrual) || 0)
            };
        }, { quantity: 0, rate: 0, netValue: 0, accrual: 0 });
        return {
            cost: costTotals,
        }
    };

    const handleDownload = (attachmentUrl) => {
        // Implement your download logic here
        console.log("Downloading:", attachmentUrl);
        // You can use window.open(attachmentUrl) or implement a proper download
        window.open(attachmentUrl, '_blank');
    };

    if (isLoading) {
        return (
            <>
                <Jobs_header />
                <div className="jobs_module">
                    <div className="loading-container">
                        <p>Loading job details...</p>
                    </div>
                </div>
            </>
        );
    }

    // Handle individual row checkbox change
    const handleRowCheckboxChange = (rowIndex, isChecked) => {
        if (isChecked) {
            setSelectedRows(prev => [...prev, rowIndex]);
        } else {
            setSelectedRows(prev => prev.filter(index => index !== rowIndex));
        }
    };

    // Handle "select all" checkbox change
    const handleSelectAllChange = (e) => {
        if (e.target.checked) {
            // Select all rows
            const allRowIndices = allCategories.flatMap(category =>
                category.rows.map((_, index) => index)
            );
            setSelectedRows(allRowIndices);
        } else {
            // Deselect all
            setSelectedRows([]);
        }
    };



    return (
        <>
            <Jobs_header onSearch={null} disableSearch={true}/>
            <div className='jobs_module'>
                <div className="jobs-module-header">
                    <div className="jobs-module-header-left">
                        <img
                            src={back_arrow}
                            alt="Back Arrow"
                            onClick={() => navigate(-1)}
                            style={{ cursor: "pointer" }}
                        />
                        <p className="new_job">{jobData.job_no || jobData.job_number || 'N/A'}</p>
                    </div>
                </div>

                <div className='jobs-module-details'>
                    <div className='jobs-module-job-details'>
                        <p className='jobs-module-jobs-details-header'>Job details</p>
                        <div className='jobs-module-details-grid'>
                            <p className='jobs-module-jobs-details-label'>Job No</p>
                            <p className='jobs-module-jobs-details-value'>{jobData.job_no || jobData.job_number || 'N/A'}</p>

                            <p className='jobs-module-jobs-details-label'>Project</p>
                            <p className='jobs-module-jobs-details-value'>{jobData.project_name || jobData.project || 'N/A'}</p>

                            <p className='jobs-module-jobs-details-label'>Date</p>
                            <p className='jobs-module-jobs-details-value'>
                                {jobData.date ? new Date(jobData.date).toLocaleDateString() : 'N/A'}
                            </p>

                            <p className='jobs-module-jobs-details-label'>Status</p>
                            <p className='jobs-module-jobs-details-value'>
                                <span className={`status-badge ${jobData.status || jobData.approval_status}`}>
                                    {jobData.status || jobData.approval_status}
                                </span>
                            </p>

                            <p className='jobs-module-jobs-details-label'>Created Date</p>
                            <p className='jobs-module-jobs-details-value'>
                                {jobData.created_date ? new Date(jobData.created_date).toLocaleDateString() : 'N/A'}
                            </p>

                            <p className='jobs-module-jobs-details-label'>Cost Accrual</p>
                            <p className='jobs-module-jobs-details-value'>
                                {Number(jobData.total_cost_accrual).toFixed(2)}
                            </p>

                            {jobData.division_type === "ff" && (
                                <>
                                    <p className='jobs-module-jobs-details-label'>Plant Code</p>
                                    <p className='jobs-module-jobs-details-value'>
                                        {jobData.ff_plant_code || 'N/A'}
                                    </p>
                                </>
                            )}
                        </div>
                    </div>

                    <div className='jobs-module-job-types'>
                        <div className='job-types-content'>
                            <p className='jobs-module-jobs-details-header'>Job types</p>
                            <div className='job-types-buttons'>
                                {jobData.sales_lines?.length > 0 ? (
                                    [...new Set(jobData.cost_lines.map(line => line.job_type_name))].map((type, index) => (
                                        <button key={index} className='jobs-module-jobs-details-data'>
                                            {type || 'N/A'}
                                        </button>
                                    ))
                                ) : (
                                    <button className='jobs-module-jobs-details-data'>N/A</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="invoice_popup_categories" style={{ marginTop: '10px' }}>
                    {allCategories.map((category, index) => {
                        const totals = calculateCategoryTotals(category);
                        return (
                            <div key={index} className="invoice_popup_outercategory">
                                <div className="invoice_popup_category_header">
                                    <div className="category_name_left" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        {/* <input type="checkbox" /> */}
                                        <span className="category_name">Job Type</span>
                                    </div>

                                    <div style={{
                                        display: "flex",
                                        gap: "12px",
                                        fontSize: '12px',
                                        flexWrap: "wrap"
                                    }}>

                                        {/* COST BOX */}
                                        <div style={{
                                            backgroundColor: "#ffffff",
                                            borderRadius: "8px",
                                            padding: "12px 16px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            width: 'auto',
                                            height: '30px',
                                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                        }}>
                                            <span style={{ color: "#007bff", fontWeight: "600" }}>COST : </span>
                                            <span style={{ color: "#000" }}>Accrual : ₹ {category.costAccrual?.toLocaleString()}</span>
                                            <span style={{
                                                width: "1px",
                                                backgroundColor: "#ccc",
                                                alignSelf: "stretch"
                                            }}></span>
                                            <span style={{ color: "#000" }}>Net total : ₹ {category.costNetTotal?.toLocaleString()}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="invoice_popup_category_subheader">
                                    <div className="invoice_popup_element_list" style={{ overflowX: "auto" }}>
                                        <div className="table-container">
                                            <table className="invoice_table">
                                                <thead>
                                                    <tr>
                                                        <th colSpan="15" style={{ backgroundColor: '#E0EFFF', padding: '10px', color: '#097BED' }}>COST</th>
                                                    </tr>
                                                    <tr>
                                                        <th style={{ backgroundColor: '#E0EFFF' }}>CHARGE CODE</th>
                                                        <th style={{ backgroundColor: '#E0EFFF' }}>DESCRIPTION</th>
                                                        <th style={{ backgroundColor: '#E0EFFF' }}>VENDOR</th>
                                                        <th style={{ backgroundColor: '#E0EFFF' }}>VENDOR INV NUMBER</th>
                                                        <th style={{ backgroundColor: '#E0EFFF' }}>VENDOR INV DATE</th>
                                                        <th style={{ backgroundColor: '#E0EFFF' }}>PO/WO NO</th>
                                                        <th style={{ backgroundColor: '#E0EFFF' }}>PO/WO Date</th>
                                                        <th style={{ padding: '10px', backgroundColor: '#E0EFFF' }}>REMARKS</th>
                                                        <th style={{ backgroundColor: '#E0EFFF' }}>ACCRUAL SPLIT</th>
                                                        <th style={{ backgroundColor: '#E0EFFF' }}>CONTRACT VALUE</th>
                                                        <th style={{ backgroundColor: '#E0EFFF' }}>QUANTITY</th>
                                                        <th style={{ backgroundColor: '#E0EFFF' }}>RATE</th>
                                                        <th style={{ backgroundColor: '#E0EFFF' }}>NET TOTAL</th>
                                                        <th style={{ backgroundColor: '#E0EFFF' }}>ATTACHMENT</th>
                                                        <th style={{ backgroundColor: '#E0EFFF' }}>INV STATUS</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {category.costRows.map((row, rowIndex) => (
                                                        <tr key={rowIndex}>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                                                    value={row.chargecode}
                                                                    className="invoice_small_input"
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    style={{ margin: '0px', fontSize: '12px', fontFamily: 'Work Sans' }}
                                                                    value={row.description}
                                                                    className="invoice_small_input"
                                                                    readOnly
                                                                />
                                                            </td>

                                                            {/* COST  VENDOR*/}
                                                            <td >
                                                                <input
                                                                    type="text"
                                                                    value={row.vendor}
                                                                    className="contracts_small_input"
                                                                    style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                    readOnly
                                                                />
                                                            </td>

                                                            {/* COST VENDOR INV NUMBER*/}
                                                            <td >
                                                                <input
                                                                    type="text"
                                                                    value={row.vendorInvNumber}
                                                                    className="contracts_small_input"
                                                                    style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                    readOnly
                                                                />
                                                            </td>

                                                            {/* COST  VENDOR INV DATE*/}
                                                            <td >
                                                                <input
                                                                    type="date"
                                                                    value={row.vendorInvDate}
                                                                    className="contracts_small_input"
                                                                    style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                    readOnly
                                                                />
                                                            </td>

                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    style={{ margin: '0px', fontSize: '12px', fontFamily: 'Work Sans' }}
                                                                    value={row.po_wo_number}
                                                                    className="invoice_small_input"
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    style={{ margin: '0px', fontSize: '12px', fontFamily: 'Work Sans' }}
                                                                    value={row.po_wo_date}
                                                                    className="invoice_small_input"
                                                                    readOnly
                                                                />
                                                            </td>


                                                            {/* COST  REMARKS*/}
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    value={row.costRemarks || ""}
                                                                    className="contracts_small_input"
                                                                    style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                    readOnly
                                                                />
                                                            </td>
                                                            {/* COST  ACCURAL*/}
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    value={row.costAccrual}
                                                                    className="invoice_narrow_input"
                                                                    style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                    readOnly
                                                                />
                                                            </td>
                                                            {/* COST  CONTRACT VALUE */}
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    style={{ margin: '0px', fontSize: '12px', fontFamily: 'Work Sans' }}
                                                                    value={row.costContractValue}
                                                                    className="invoice_narrow_input"
                                                                    readOnly />
                                                            </td>
                                                            {/* COST  QUANTITY*/}
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    style={{ margin: '0px', fontSize: '12px', fontFamily: 'Work Sans' }}
                                                                    value={row.costunitQuantity}
                                                                    className="invoice_narrow_input_quantity"
                                                                    readOnly />
                                                            </td>
                                                            {/* COST  RATE*/}
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    value={row.costRate}
                                                                    className="invoice_narrow_input"
                                                                    style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                    readOnly
                                                                />
                                                            </td>
                                                            {/* COST  NET TOTAL*/}
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    value={row.costNetTotal}
                                                                    readOnly
                                                                    className="invoice_narrow_input"
                                                                    style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                />
                                                            </td>
                                                            {/* COST  ATTACHMENT*/}
                                                            <td>
                                                                {row.costAttachmentUrl && (
                                                                    <div className="file_upload_wrapper">
                                                                        <div className="download_file_item">
                                                                            <button
                                                                                onClick={() => handleDownload(row.costAttachmentUrl)}
                                                                                className="download_btn"
                                                                            >
                                                                                <img src={download_arrow} alt="Download" className="file_icon" />
                                                                                <span className="download_text">Download</span>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            {/* COST INVOICE STATUS */}
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    value={row.costInvStatus || ""}
                                                                    className="contracts_small_input"
                                                                    style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                    readOnly
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <CommonFooter />
            <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} />
        </>
    );
};

export default GenerateCostViewPage
